const product = {
  add_tags: 'Aggiungi i codici prodotto',
  blister: 'Blister',
  cpa: 'anno in corso',
  cpa_1m: '1 mese',
  cpa_12m: '12 mesi (rolling)',
  cpa_3m: '3 mesi',
  cpa_all: 'anno in corso + precendente',
  cpa_prev: 'anno precendente',
  package: 'Confezione',
  pallet: 'Pallet',
  last_sell_date: 'Data ultima vendita',
  search_codes: 'Cerca tra i codici prodotto',
  qta_min_handling: 'Quantità minima di handling',
  qta_min: 'Quantità minima in acquisto',
  qta_min_sell: 'Quantità minima in vendita',
  cmp: 'CMP',
  cmp_net_net: 'CMP net net',
  cost: 'Costo in vigore',
  cost_net_net: 'Costo in vigore net net',
}

export default product